import React, { useState } from "react";
import "./AppTable.css";

const initialsOf = (name) =>
  (name || "?")
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();

/// Avatar + name + secondary line (e.g. email) for a table cell. Falls back
/// to initials when there is no avatar or it fails to load. `size="sm"` gives
/// a compact one-line variant.
const TableUser = ({ avatar, name, subtitle, size }) => {
  const [failed, setFailed] = useState(false);
  const showImage = avatar && !failed;

  return (
    <div
      className={`app-table-user${size === "sm" ? " app-table-user--sm" : ""}`}
    >
      <span className="app-table-user__avatar">
        {showImage ? (
          <img src={avatar} alt="" onError={() => setFailed(true)} />
        ) : (
          initialsOf(name)
        )}
      </span>
      <span className="app-table-user__info">
        <span className="app-table-user__name" title={name}>
          {name || "-"}
        </span>
        {subtitle && (
          <span className="app-table-user__sub" title={subtitle}>
            {subtitle}
          </span>
        )}
      </span>
    </div>
  );
};

export default TableUser;
